<template>
  <v-container>
    <upload-addresses/>
    <br/>
    <upload-accounts/>
  </v-container>
</template>

<script>
import UploadAddresses from '@/components/UploadAddresses'
import UploadAccounts from '@/components/UploadAccounts'

export default {
  name: 'Admin',
  components: {UploadAddresses, UploadAccounts},
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin.vue